<template>
  <div class="share-obituary-comment-links">
    <div class="share-obituary-comment__button-group">
      <button class="btn outline brand-facebook" @click.prevent="shareFacebook">
        <svg class="icon"><use href="#facebook" /></svg>
        Facebook
      </button>

      <button
        class="btn outline brand-facebook"
        @click.prevent="shareMessenger"
      >
        <svg class="icon"><use href="#facebook-messenger" /></svg>
        Messenger
      </button>

      <a
        class="btn outline brand-whatsapp"
        :href="`https://api.whatsapp.com/send?phone=&text=${whatsappMessageBody}`"
        rel="noreferrer nofollow"
        target="__blank"
      >
        <svg class="icon"><use href="#whatsapp" /></svg>
        WhatsApp
      </a>
    </div>

    <label v-text="`${texts.shareCommentLinks.copyAndShare}:`" />
    <div class="obituary-single__share-link">
      <input ref="copyLink" type="text" readonly :value="shareLink" />
      <button class="btn btn-cta" @click.prevent="copyLink">
        {{ texts.common.copy }}
      </button>
    </div>
  </div>
</template>

<script>
import { sprintf } from 'sprintf-js';

export default {
  name: 'ShareCommentLinks',

  props: {
    deceasedName: {
      type: String,
      required: true,
    },
    shareLink: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      texts: lavendlaObituary,
    };
  },

  computed: {
    whatsappMessageBody() {
      return sprintf(
        this.texts.shareCommentLinks.whatsAppMessage,
        this.deceasedName,
        this.shareLink
      );
    },
  },

  methods: {
    shareFacebook() {
      FB.ui(
        {
          method: 'share',
          href: this.shareLink,
        },
        function (response) {}
      );
    },

    shareMessenger() {
      FB.ui(
        {
          method: 'send',
          link: this.shareLink,
        },
        function (response) {}
      );
    },

    copyLink() {
      this.$refs.copyLink.select();
      document.execCommand('copy');
    },
  },
};
</script>
